import React, { useContext } from 'react';

import { PacksDispatchContext } from './ApiProvider';

import EditIcon from 'Assets/icons/edit.svg';

export default function CategoriesToPacks({ categories, isContractor = false, isLoaded }) {
    const apiCall = useContext(PacksDispatchContext);

    const handleEditCategory = (id) => {
        apiCall('form', {
            type: isContractor ? 'createContractorCategory' : 'createSimpleCategory',
            id,
        });
    };

    if (!isLoaded) {
        return null;
    }

    const visibleCategories = (categories || []).filter((cat) => !cat.deleted).sort((a, b) => (a.name || '').localeCompare(b.name || ''));

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-space-y-2 tw-overflow-auto tw-w-2/3 max-lg:tw-w-full">
            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                <div className="tw-p-2.5 tw-flex tw-gap-2 tw-text-sm tw-font-semibold tw-text-charcoal">
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{$t('Category')}</div>
                    </div>
                    {!!window.canSave && <div className="tw-basis-6 tw-shrink-0"></div>}
                </div>
            </div>
            <div className="tw-space-y-2">
                {visibleCategories.length > 0 ? (
                    visibleCategories.map((category) => (
                        <div key={category.id} className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-bg-white tw-overflow-hidden">
                            <div className="tw-w-full tw-p-2.5 tw-flex tw-items-center tw-gap-2 tw-text-left tw-text-sm tw-text-charcoal hover:tw-bg-gray-100">
                                <span className="tw-flex-1">{category.name}</span>
                                {!!window.canSave && (
                                    <button
                                        type="button"
                                        className="tw-shrink-0 tw-p-1 hover:tw-bg-gray-500 tw-rounded"
                                        onClick={() => handleEditCategory(category.id)}
                                        aria-label={$t('Edit category')}
                                    >
                                        <EditIcon className="tw-w-4 tw-h-4 tw-text-charcoal" />
                                    </button>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="tw-text-sm tw-text-charcoal-50">{$t('No categories found')}</p>
                )}
            </div>
        </div>
    );
}
